






























import { Vue, Component, Prop, Ref } from 'vue-property-decorator';

import CalendarLayout from './CalendarLayout.vue';
import CalendarView from './CalendarView.vue';
import CalendarServices from './CalendarServices.vue';

import SlotView from './forms/SlotView.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { CalendarType, SlotsClinicMap, SlotType } from '@/components/calendar/types';
import { Slot } from './types';

import { getTodayDate } from '@/utils/date';

import { SlotsMap } from './types';
import { Maybe } from '@/types/common';
import { ISOCalendarDate, ISODateRange } from '@/utils/date/types';

@Component({
    components: {
        CalendarLayout,
        CalendarView,
        CalendarServices,
        SlotView,
        BaseButton,
    },
})
export default class CalendarDoctor extends Vue {
    @Prop({ default: () => ({}) }) slots!: SlotsMap
    @Prop({ default: () => ({}) }) slotsClinic!: SlotsClinicMap
    @Ref() readonly calendar!: CalendarView;

    date = getTodayDate();

    selectedSlot: Maybe<Slot> = null;

    dateToRemove: ISOCalendarDate | '' = ''

    loadSlots(range: ISODateRange) {
        this.$emit('slots:load', range)
    }

    selectSlot(slot: Slot) {
        this.closeConsultationPanel();

        if (slot.type === SlotType.Reserved) {
            this.selectedSlot = slot;
        }
    }

    isMonthView(type: CalendarType) {
        return type === CalendarType.Month;
    }

    goPreviousPage() {
        this.calendar.goPreviousPage();
    }

    goNextPage() {
        this.calendar.goNextPage();
    }

    createConsultation(consultation: any) {
        this.$emit('create:consultation', consultation);
    }

    closeConsultationPanel() {
        this.selectedSlot = null;
    }
}
